<app-loading
  [loading] = loading
></app-loading>
<ng-container *ngIf="!isModal">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <div class="content-wrapper">
    <section class="content">
      <app-breadcrumb
        Titulo="Novo processo"
        Pagina="Novo"
        [TemPaginaPai] = true
        LinkPaginaPai="/juridico/processo"
        PaginaPai="Processo"
      ></app-breadcrumb>
      <div class="row" style="width: 101%">
        <div class="col-md-12">
          <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<div class="modal-overlay" *ngIf="isModal && modalNovoProcesso" (click)="!loading && fecharModal()">
  <div class="box-atendimento-novo" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-balance-scale"></i> Novo Processo
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
  </div>
</div>

<ng-template #formTemplate>
  <div [ngClass]="{'card card-blue': !isModal}">
    <form [formGroup]="formCadastrar" id="formCadastrar">
      <div [ngClass]="{'card-body': !isModal}">
        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="solicitante">Cliente</label>
              <div class="custom-select-container">
                <i class="fa fa-user icon"></i>
                <ng-select
                  id= "solicitante"
                  [items]="itensSolicitantes | async"
                  bindLabel="descricao"
                  bindValue="id"
                  (change)="buscarAtendimento()"
                  formControlName="solicitante">
                </ng-select>
              </div>
              <div class="d-flex justify-content-end align-items-center mt-1">
                <div class="microbotao" style="cursor: pointer;" (click)="modalCliente()">+ Cliente</div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="atendimento">Atendimento</label>
              <div class="custom-select-container">
                <i class="fa fa-phone icon"></i>
                <ng-select
                  id= "atendimento"
                  [items]="itensAtendimentos | async"
                  bindLabel="descricao"
                  bindValue="id"
                  formControlName="atendimento">
                </ng-select>
              </div>
              <div class="d-flex justify-content-end align-items-center mt-1">
                <div class="microbotao" *ngIf="showBotaoAtendimento" style="cursor: pointer;" (click)="modalAtendimento()">+ Atendimento</div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="pasta">Pasta</label>
              <div class="custom-select-container">
                <i class="fa fa-suitcase icon"></i>
                <ng-select
                  id= "pasta"
                  [items]="itensPasta | async"
                  bindLabel="descricao"
                  bindValue="id"
                  formControlName="pasta">
                </ng-select>
              </div>
              <div class="d-flex justify-content-end align-items-center mt-1">
                <div class="microbotao" *ngIf="showBotaoPasta" style="cursor: pointer;" (click)="modalPasta()">+ Pasta</div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="nomeOutraParte">Outros envolvidos</label>
              <div class="custom-select-container">
                <i class="fa fa-user-secret icon"></i>
                <input type="text" (focusout)="gerarTitulo()" id="nomeOutraParte" formControlName="nomeOutraParte" class="form-control">
              </div>
            </div>
          </div>
          <div [ngClass]="isModal ? 'col-md-12 mb-3' : 'col-md-8 mb-3'">
            <div class="form-group">
              <label for="titulo">Titulo</label>
              <div class="custom-select-container">
                <i class="fa fa-font icon"></i>
                <input type="text" id="titulo" formControlName="titulo" class="form-control">
              </div>
            </div>
          </div>
          <div class="form-group mb-3" [ngClass]="isModal ? 'col-md-12' : 'col-md-4'">
            <label for="tipoAcao">Ação</label>
            <div class="custom-select-container">
              <i class="fa fa-balance-scale icon"></i>
              <ng-select
                class="ng-select-custom"
                formControlName="tipoAcao"
                id="tipoAcao"
                [items]="listaTipoAcao"
                bindLabel="descricao"
                bindValue="id"
                [clearable]="false"
                placeholder="Selecione"
                [ngClass]="{ 'form-erro': (formCadastrar.controls['tipoAcao'].invalid)
                          && formCadastrar.controls['tipoAcao'].touched }"
              >
              </ng-select>
            </div>
            <div class="d-flex justify-content-end align-items-center mt-1">
              <div class="microbotao" style="cursor: pointer;" (click)="modalTipoAcao()">+ Ação</div>
            </div>
            <span id="tipoConta-error-required" class="error mensagem-erro"
                  *ngIf="formCadastrar.controls['tipoAcao'].touched && formCadastrar.controls['tipoAcao'].errors?.required"
            >A ação não pode ser vazio<br></span>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <label for="descricao">Objeto:</label>
              <angular-editor id="descricao"
                              [config]="editorConfig"
                              formControlName="descricao"></angular-editor>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn btn-light" (click)="voltar()" [disabled]="loading">
              {{ isModal ? 'Cancelar' : 'Voltar' }}
            </button>
            <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="loading">
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ loading ? 'Salvando...' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<app-novo-atendimento
  [isModal]="true"
  (atualizarLista)="buscarAtendimento()"
></app-novo-atendimento>

<app-novo-cliente
  [habilitarNovo]="showModalCliente"
  (fecharModalCalled)="fecharModalCliente()"
  (atualizarListaCalled)="listarClientes()"
></app-novo-cliente>

<app-nova-pasta
  [pessoaId]="formCadastrar.get('solicitante')?.value"
  (atualizarListaCalled)="listarPastas(formCadastrar.get('solicitante')?.value)"
></app-nova-pasta>

<app-novo-tipo-acao
  (atualizarListaCalled)="listarTipoAcao()"
></app-novo-tipo-acao>
